<template>
  <div class="card">
    <div class="situacao-main">
      <h6
        class="situacao"
        :class="{
          programada: getStatusEfetivo(props.atividade) === 'PROGRAMADA',
          encerrada: getStatusEfetivo(props.atividade) === 'ENCERRADA',
          cancelada: getStatusEfetivo(props.atividade) === 'CANCELADA',
          'inscricoes-abertas': getStatusEfetivo(props.atividade) === 'INSCRICOES_ABERTAS',
          'em-execucao': getStatusEfetivo(props.atividade) === 'EM_EXECUCAO',
        }"
      >
        {{ formatarEnum(getStatusEfetivo(props.atividade)) }}
      </h6>
    </div>

    <img
      class="card-img-top"
      :src="props.atividade.imagemUrl"
      :alt="props.atividade.nome"
      @click="abrirAtividade()"
    />

    <div 
      class="card-body"
      @click="abrirAtividade()"
    >
      <div class="card-head">
        <h5>
          <span
            v-if="props.atividade.siglaAcao"
            class="sigla-inline-badge"
            :style="getCorSigla(props.atividade)"
          >
            {{ props.atividade.siglaAcao.toUpperCase() }}
          </span>
          <span v-if="props.atividade.siglaAcao"> - </span>
          {{ props.atividade.nome.toUpperCase() }}
        </h5>

        <p id="vagas">
          Vagas:
          <span
            v-if="
              !isCriterioCoordenacao(props.atividade) &&
              (props.atividade.vagaAbertas === 0 ||
                props.atividade.vagasAbertas === 0 ||
                props.atividade.vagasRestantes === 0)
            "
            style="color: #d32f2f; font-weight: 700"
          >
            Esgotadas
          </span>
          <span
            v-else-if="isCriterioCoordenacao(props.atividade)"
          >
            {{ props.atividade.numeroDeVagasOfertadas || "ilimitadas" }}
          </span>
          <span
            v-else-if="
              props.atividade.vagaAbertas != null ||
              props.atividade.vagasAbertas != null ||
              props.atividade.vagasRestantes != null
            "
          >
            {{
              props.atividade.vagaAbertas ??
              props.atividade.vagasAbertas ??
              props.atividade.vagasRestantes
            }}
          </span>
          <span v-else>
            {{ props.atividade.numeroDeVagasOfertadas || "ilimitadas" }}
          </span>
        </p>

        <p>
          {{ subtipo?.nome || "Sem subtipo" }}
          {{ formatarEnum(props.atividade?.modalidadeExecucao) }}
        </p>
      </div>

      <div id="descricao" v-if="props.atividade.descricao">
        <p class="card-text">
          <strong>Descrição:</strong> {{ props.atividade.descricao }}
        </p>
      </div>

      <div id="infos">
        <p class="card-text">Local: {{ props.atividade.local }}</p>

        <p
          class="card-text"
          v-if="props.atividade.modalidadeInscricao === 'NESCESSITA_INSCRICAO'"
        >
          Inscrições: de
          {{ formatarDataHora(props.atividade.dataInicioInscricao) }}
          a
          {{ formatarDataHora(props.atividade.dataFimInscricao) }}
        </p>
        <p
          v-if="
            props.atividade.modalidadeInscricao === 'NESCESSITA_INSCRICAO' &&
            tempoRestanteInscricao(props.atividade.dataInicioInscricao)
          "
          class="timer-countdown"
        >
          ⏳
          {{ tempoRestanteInscricao(props.atividade.dataInicioInscricao) }}
        </p>

        <p
          v-if="props.atividade.dataEncerramento"
          class="card-text"
        >
          Encerramento:
          {{ formatarData(props.atividade.dataEncerramento) }}
        </p>

        <p
          v-if="props.atividade.dataCancelamento"
          class="card-text"
        >
          Cancelada em:
          {{ formatarData(props.atividade.dataCancelamento) }}

          <span v-if="props.atividade.motivoCancelamento">
            - Motivo:
            {{ props.atividade.motivoCancelamento }}
          </span>
        </p>
      </div>
    </div>

    <div class="botoes" @click.stop>
      <span
        v-if="jaInscrito"
        class="badge-inscrito-card"
      >
        <i class="ti ti-circle-check"></i> Inscrito(a)
      </span>

      <button
        v-else-if="checkInscricao()"
        type="button"
        @click.stop="acaoInscreverCard()"
        class="btn-card btn-inscrever-card inscrever"
      >
        Inscrever-se
      </button>

      <button
        v-if="checkEdicao()"
        type="button"
        @click.stop="abrirEdicao()"
        class="btn-card btn-editar-card editar"
      >
        <i class="ti ti-edit"></i>
        Editar
      </button>
    </div>

    <ModalLoginObrigatorio
      :visivel="mostrarModalLogin"
      :nomeAtividade="props.atividade?.nome"
      @fechar="mostrarModalLogin = false"
    />
  </div>
</template>

<script setup>
import ModalLoginObrigatorio from "@/components/common/ModalLoginObrigatorio.vue";
import userInfos from "@/utils/userInfos";
import acaoService from "@/service/acaoService";
import { useAtividades } from "@/composables/useAtividades";
import { useParticipantesAtividade } from "@/composables/useParticipantesAtividade";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import {
  formatarData,
  formatarDataHora,
  formatarEnum,
  limitarTexto,
} from "@/utils/FormatarEntradas";
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";

const props = defineProps({
  atividade: {
    type: Object,
    required: true,
  },
  isCoordenador: {
    type: Boolean,
    default: null,
  },
});

const route = useRoute();
const { subtipo, fetchSubTipoPorId } = useAtividades();
const {
  checkUsuarioLogadoInscrito,
} = useParticipantesAtividade();

const isCoordenadorLocal = ref(false);
const jaInscrito = ref(false);
const mostrarModalLogin = ref(false);
const agora = ref(Date.now());
let timerInterval = null;

const ehCoordenador = computed(() => {
  if (props.isCoordenador !== null && props.isCoordenador !== undefined) {
    return props.isCoordenador;
  }
  return isCoordenadorLocal.value;
});

function abrirAtividade() {
  const acaoId = route.params.id;
  if (acaoId) {
    router.push({
      name: "atividade-acao",
      params: { id: acaoId, atividadeId: props.atividade.id },
    });
  } else {
    router.push({
      name: "AtividadeView",
      params: { atividadeId: props.atividade.id },
    });
  }
}

function isUsuarioAutenticado() {
  const user = userInfos.getUserInfos();
  const token = window.localStorage.getItem("auth_token");
  if (!user || !user.userId || !token) {
    return false;
  }
  return !userInfos.tokenExpirado(user);
}

function acaoInscreverCard() {
  if (!checkInscricao()) {
    return;
  }
  if (!isUsuarioAutenticado()) {
    mostrarModalLogin.value = true;
    return;
  }
  abrirAtividade();
}

function tempoRestanteInscricao(dataInicioStr) {
  if (!dataInicioStr) return "";
  const dataInicio = new Date(dataInicioStr).getTime();
  if (isNaN(dataInicio)) return "";

  const diffMs = dataInicio - agora.value;
  if (diffMs <= 0) return "";

  const limiteMs = 3 * 24 * 3600 * 1000;
  if (diffMs > limiteMs) return "";

  const totalSegundos = Math.floor(diffMs / 1000);
  const dias = Math.floor(totalSegundos / 86400);
  const horas = Math.floor((totalSegundos % 86400) / 3600);
  const minutos = Math.floor((totalSegundos % 3600) / 60);
  const segundos = totalSegundos % 60;

  const partes = [
    dias > 0 && `${dias}d`,
    (dias > 0 || horas > 0) && `${horas}h`,
    (dias > 0 || horas > 0 || minutos > 0) && `${minutos}m`,
    `${segundos}s`,
  ].filter(Boolean);

  return `Abre em: ${partes.join(" ")}`;
}

function isCriterioCoordenacao(atividade) {
  if (!atividade) return false;
  return (
    atividade.criterioInscricao === "CRITERIODACOORDENACAO" ||
    atividade.criterioInscricao === "CRITERIO_DA_COORDENACAO" ||
    atividade.criterioInscricao === "Critério da Coordenação"
  );
}

function isVagasEsgotadas(atividade) {
  if (!atividade) return false;
  if (isCriterioCoordenacao(atividade)) {
    return false;
  }
  const vagas =
    atividade.vagaAbertas ?? atividade.vagasAbertas ?? atividade.vagasRestantes;
  if (vagas !== undefined && vagas !== null) {
    return Number(vagas) === 0;
  }
  return false;
}

function isAntesDeAbrirInscricao(atividade) {
  if (!atividade || atividade.modalidadeInscricao !== "NESCESSITA_INSCRICAO") {
    return false;
  }
  if (!atividade.dataInicioInscricao) return false;
  const dataInicio = new Date(atividade.dataInicioInscricao).getTime();
  if (isNaN(dataInicio)) return false;
  return agora.value < dataInicio;
}

function isPeriodoInscricaoEncerrado(atividade) {
  if (!atividade || atividade.modalidadeInscricao !== "NESCESSITA_INSCRICAO") {
    return false;
  }
  if (!atividade.dataFimInscricao) return false;
  const dataFim = new Date(atividade.dataFimInscricao).getTime();
  if (isNaN(dataFim)) return false;
  return agora.value > dataFim;
}

function getStatusEfetivo(atividade) {
  if (!atividade?.status) return "";
  // Retorna sempre o status real do backend — "ENCERRADA" é definida
  // pelo responsável, não calculada automaticamente por data.
  if (
    [
      "CANCELADA",
      "ENCERRADA",
      "FINALIZADO",
      "CONCLUIDA",
      "EM_EXECUCAO",
      "FINALIZANDO",
    ].includes(atividade.status)
  ) {
    return atividade.status;
  }
  if (atividade.modalidadeInscricao === "NESCESSITA_INSCRICAO") {
    if (isAntesDeAbrirInscricao(atividade)) {
      return "PROGRAMADA";
    }
    if (isPeriodoInscricaoEncerrado(atividade)) {
      return "PROGRAMADA";
    }
  }
  return atividade.status;
}

function checkInscricao() {
  if (
    props.atividade.modalidadeInscricao &&
    props.atividade.modalidadeInscricao !== "NESCESSITA_INSCRICAO"
  ) {
    return false;
  }
  if (isVagasEsgotadas(props.atividade)) {
    return false;
  }
  if (isAntesDeAbrirInscricao(props.atividade)) {
    return false;
  }
  if (isPeriodoInscricaoEncerrado(props.atividade)) {
    return false;
  }
  return getStatusEfetivo(props.atividade) === "INSCRICOES_ABERTAS";
}

function checkEdicao() {
  const auth = useAuthStore();
  return (
    (auth.hasRole("ADMINISTRADOR") || ehCoordenador.value) &&
    !["ENCERRADA", "CANCELADA", "EM_EXECUCAO"].includes(props.atividade?.status)
  );
}

async function checarPermissaoCoordenador() {
  if (props.isCoordenador !== null && props.isCoordenador !== undefined) {
    return;
  }
  const acaoUrl = props.atividade?.acaoUrl?.split("/") || [];
  const targetAcaoId = route.params.id || acaoUrl[acaoUrl.length - 1];
  if (targetAcaoId) {
    try {
      isCoordenadorLocal.value = await acaoService.verificarCoordenador(targetAcaoId);
    } catch {
      isCoordenadorLocal.value = false;
    }
  }
}

watch(
  () => props.isCoordenador,
  (novoValor) => {
    if (novoValor === null || novoValor === undefined) {
      checarPermissaoCoordenador();
    }
  }
);

function abrirEdicao() {
  const acaoUrl = props.atividade.acaoUrl?.split('/') || [];
  const acaoId = acaoUrl[acaoUrl.length - 1];

  if (acaoId && props.atividade.id) {
    router.push({
      name: "editar-atividade",
      params: { id: acaoId, atividadeId: props.atividade.id },
    });
  }
}

function getCorSigla() {
  return {
    backgroundColor: props.atividade.acaoCorSigla || "#48298a",
    borderColor: props.atividade.acaoCorSigla || "#48298a",
    color: "#fff",
  };
}

onMounted(async () => {
  timerInterval = setInterval(() => {
    agora.value = Date.now();
  }, 1000);

  checarPermissaoCoordenador();

  if (props.atividade.idSubtipo) {
    await fetchSubTipoPorId(props.atividade.idSubtipo);
  }

  const auth = useAuthStore();
  if (auth.user && props.atividade.id) {
    checkUsuarioLogadoInscrito(props.atividade.id).then((res) => {
      jaInscrito.value = Boolean(res);
    });
  }
});

onUnmounted(() => {
  if (timerInterval) {
    clearInterval(timerInterval);
  }
});
</script>

<style scoped>
.card {
  background-color: transparent;
  overflow: hidden;
  border-radius: 10px;
  width: 100%;
  height: 235px;
  max-height: 235px;
  display: flex;
  align-items: stretch;
  flex-direction: row;
  gap: 12px;
  position: relative;
}

p {
  margin: 0;
}

.card-img-top {
  width: 200px;
  min-width: 200px;
  max-width: 208px;
  height: 215px;
  max-height: 215px;
  object-fit: cover;
  background-size: cover;
  margin-top: 10px;
  border-radius: 8px;
  flex-shrink: 0;
  border: 1px solid hsl(258, 25%, 93%);
}

.card-body {
  padding: 8px 12px 8px 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  height: 235px;
  max-height: 235px;
  gap: 5px;
  overflow: hidden;
}

.card-head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
}

.card-head p,
#infos p,
#descricao p {
  margin: 0;
  padding: 0;
  line-height: 1.38;
  font-size: 14px;
  color: hsl(258, 15%, 32%);
}

#descricao strong,
#vagas strong,
#infos strong {
  color: hsl(258, 40%, 25%);
}

.sigla-inline-badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 700;
  vertical-align: text-bottom;
}

.situacao-main {
  position: relative;
  width: 44px;
  height: 100%;
  align-self: stretch;
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-shrink: 0;
}

.situacao {
  color: #fff;
  margin: 0;
  padding: 10px 4px;
  width: 100%;
  height: 100%;
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex: 1;
  border-radius: 10px 0 0 10px;
}

.programada {
  background-color: var(--azul-claro);
}
.encerrada {
  background-color: #2e7d32;
}
.cancelada {
  background-color: red;
}
.inscricoes-abertas {
  background-color: #722fa2;
}
.em-execucao {
  background-color: #ff7b00;
}

h5 {
  font-size: 1.05rem;
  font-weight: 700;
  color: hsl(258, 53%, 22%);
  margin: 0 0 2px 0;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

#infos {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0;
  font-size: 14px;
  word-wrap: break-word;
  flex-shrink: 0;
}

#descricao {
  margin: 0;
  overflow: hidden;
  min-height: 0;
  flex-shrink: 1;
}

#descricao .card-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.38;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.botoes {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  z-index: 2;
}

.btn-card {
  font-size: 0.82rem;
  font-weight: 600;
  padding: 5px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  user-select: none;
  line-height: 1.4;
}

.btn-card:hover {
  transform: translateY(-1px);
}

.btn-editar-card,
.editar {
  background-color: var(--azul-escuro);
  color: var(--branco);
}

.btn-editar-card:hover,
.editar:hover {
  background-color: hsl(221, 100%, 28%);
}

.btn-inscrever-card,
.inscrever {
  background-color: var(--roxo-claro);
  color: var(--branco);
}

.btn-inscrever-card:hover,
.inscrever:hover {
  background-color: hsl(278, 55%, 33%);
}

.btn-desabilitado {
  background: #9e9e9e !important;
  cursor: not-allowed !important;
  opacity: 0.65;
}

.btn-desabilitado:hover {
  background: #9e9e9e !important;
}

.timer-countdown {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background-color: rgba(255, 123, 0, 0.1);
  color: #e65100;
  border: 1px solid rgba(255, 123, 0, 0.2);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: 2px;
  width: fit-content;
}

.badge-inscrito-card {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  background-color: hsl(142, 60%, 93%);
  color: hsl(142, 70%, 25%);
  border: 1px solid hsl(142, 60%, 80%);
  border-radius: 99px;
  font-size: 0.8rem;
  font-weight: 700;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  user-select: none;
}
</style>
